export function getHeaderItems (mode) {
    return { type: "HANDLE_HEADERITEMS", payload: mode };
  }
  
export function updateHeaderItems (mode){
  return { type: "UPDATE_HEADERITEMS", payload: mode };

}
